import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

@Component({
  selector: 'app-hr-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './hr-hero.html',
  styleUrls: ['./hr-hero.css'],
})
export class HrHeroComponent {
  showRegister = false;
  hrApp = [{ name: 'HR', image: 'images/webps/hr.svg' }];
}
